module.exports = function(fn) {
  return function(a, b) {
    return fn.apply(null, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/arity-n/2.js
// module id = ./node_modules/arity-n/2.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons